import React from 'react';
import ReactDOM from 'react-dom/client';
import 'antd/dist/reset.css';
import '@spark/shared-ui/styles.css';
import './styles.css';
import { SparkThemeProvider } from '@spark/shared-ui';
import { App } from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SparkThemeProvider>
      <App />
    </SparkThemeProvider>
  </React.StrictMode>,
);
